import React from 'react';
import PropTypes from 'prop-types';
import defaultTheme from '@styles/theme';

function Star(props) {
  const { active, ...restProps } = props;
  const iconSize = {
    width: props.width || 32,
    height: props.height || 32
  };
  return (
    <svg
      className="Star__icon"
      viewBox="0 0 102 96"
      version="1.1"
      {...iconSize}
      {...restProps}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <polygon
          fill={active ? '#F9BE3E' : defaultTheme.colors.secondary}
          points="51 83.1013765 21.6107374 93.4508497 22.3718897 62.3018369 3.44717419 37.5491503 33.3068548 28.6474749 51 3 68.6931452 28.6474749 98.5528258 37.5491503 79.6281103 62.3018369 80.3892626 93.4508497"
          stroke="#FFFFFF"
          strokeWidth="5"
        />
      </g>
    </svg>
  );
}

Star.propTypes = {
  active: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Star;
